import React from 'react';
import PropTypes from 'prop-types';
import { MainProductImageContainer, MainProductImageContent } from '../styles/MainProductImage';

const MainProductImage = props => (
  <MainProductImageContainer
    selected={props.selected}
    small={props.small}
    insideList={props.insideList}
    swipe={props.swipe}
    round={props.round}
  >
    <MainProductImageContent small={props.small}>{props.children}</MainProductImageContent>
  </MainProductImageContainer>
);

MainProductImage.defaultProps = {
  selected: false,
  small: false,
  insideList: false,
  swipe: null,
  round: false
};

MainProductImage.propTypes = {
  selected: PropTypes.bool,
  small: PropTypes.bool,
  insideList: PropTypes.bool,
  swipe: PropTypes.number,
  round: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default MainProductImage;



// WEBPACK FOOTER //
// ./src/components/MainProductImage.js